<h2>{{ "dashboard_welcome" | transloco }}</h2>

<div class="dashboard-container">
    @for (dashboardItem of dashboardItems; track dashboardItem) {
        <div class="drag-item">
            <ng-container *ngComponentOutlet="dashboardItem.component"></ng-container>
        </div>
    }
</div>
